import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-message-container-loading',
  templateUrl: './message-container-loading.component.html',
  styleUrl: './message-container-loading.component.scss'
})
export class MessageContainerLoadingComponent {
  @Input() message: string = '';
}